module.exports = __webpack_public_path__ + "img/img3.cf82334a.svg";